import qs from 'qs';
import { GapOfferMapFilter, GapOfferMarker } from 'types/gapOffer';
import { Complex } from 'types/offer';
import { CommonResponse, get } from './clientAxios';

export async function getGapOfferMarkerInformations(
  mapData: GapOfferMapFilter,
) {
  try {
    const response = await get<CommonResponse<GapOfferMarker[]>>(
      '/api/complex/gap/mapList',
      {
        params: mapData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      },
    );

    const { data } = response.data;
    return { error: false, data };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function getGapComplexInformation(complexId: number) {
  try {
    const response = await get<CommonResponse<Complex>>(
      `/api/complex/complexGapInfo`,
      {
        params: { complexId },
      },
    );
    const result = response.data.data;

    return { error: false, data: result };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}
